// extracted by mini-css-extract-plugin
export default {"box":"Institutions_box__dDsaU","list":"Institutions_list__JemMV","dragArea":"Institutions_dragArea__u10k3"};